import { api } from 'api'
import { Pagination } from 'interfaces/api.interfaces'
import { Manual, Manuals, RemoveManualParams, UpdateManualParams } from 'interfaces/api/manuals.interfaces'
import { createAsyncThunk } from 'modules/store'

export const getPromo = createAsyncThunk('manuals/promo', async (params: Partial<Pagination>, { rejectWithValue }) =>
  api.manuals.getAll(Manuals.Promo, params).catch((error) => rejectWithValue(error.message)),
)

export const getBudget = createAsyncThunk('manuals/budget', async (params: Partial<Pagination>, { rejectWithValue }) =>
  api.manuals.getAll(Manuals.Budget, params).catch((error) => rejectWithValue(error.message)),
)

export const getMechanics = createAsyncThunk(
  'manuals/mechanics',
  async (params: Partial<Pagination>, { rejectWithValue }) =>
    api.manuals.getAll(Manuals.Mechanics, params).catch((error) => rejectWithValue(error.message)),
)

export const getCondition = createAsyncThunk(
  'manuals/condition',
  async (params: Partial<Pagination>, { rejectWithValue }) =>
    api.manuals.getAll(Manuals.Condition, params).catch((error) => rejectWithValue(error.message)),
)

export const updateManual = createAsyncThunk('manuals/update', async (data: UpdateManualParams, { rejectWithValue }) =>
  api.manuals
    .update(data.type, data.manual)
    .then(() => {
      data.onSuccess?.()
    })
    .catch((error) => rejectWithValue(error.message)),
)

export const createManual = createAsyncThunk('manuals/create', async (data: UpdateManualParams, { rejectWithValue }) =>
  api.manuals
    .create(data.type, data.manual)
    .then(() => {
      data.onSuccess?.()
    })
    .catch((error) => rejectWithValue(error.message)),
)

export const removeManual = createAsyncThunk('manuals/remove', async (data: RemoveManualParams, { rejectWithValue }) =>
  api.manuals
    .remove(data.type, data.id)
    .then(() => {
      data.onSuccess?.()
    })
    .catch((error) => rejectWithValue(error.message)),
)
